/**
 * 物語の絵（`assets/images/story/`）を ID から引く（#900）。
 *
 * `EventBody.vue` が持っていた glob をここに出した。手記の一覧（`MemoirListDialog`）も
 * 同じ絵を出すので、**glob は 1 か所**に置く。
 *
 * ⚠️ **eager glob なので、ここに置いた絵はビルドの assets に載る**（= その chunk が
 * prefetch されるとき一緒に落ちてくる）。絵を足したら増分を実測すること（#784 / #899）。
 * 実測の手順は `doc/developers/frontend_performance.md`。
 */
// glob は**このファイルからの相対パス**で書く。ルート絶対（`/assets/...`）だと Vite の
// root がどこかに依存し、vitest（@nuxt/test-utils）では 1 件も引けなくなる —— 絵が出ない
// ことを単体テストで見張れなくなるので、相対で書くこと。
const iconMap: Record<string, { default: string }> = import.meta.glob('../assets/images/story/Icon_*.webp', { eager: true })
const imageMap: Record<string, { default: string }> = import.meta.glob('../assets/images/story/Image_*.webp', { eager: true })

export function useStoryImage() {
  /** 話者アイコン（`Icon_<id>.webp`）。 */
  const resolveIcon = (id: string): string | undefined =>
    iconMap[`../assets/images/story/Icon_${id}.webp`]?.default

  /**
   * 挿絵（`Image_<id>.webp`）。
   *
   * 未生成の挿絵を指していても落とさない（手記は挿絵が後から差し替わる前提。#899）。
   * 呼び出し側は undefined を「額の中身がまだ無い」として扱うこと。
   */
  const resolveImage = (id: string | null | undefined): string | undefined => {
    if (!id) return undefined
    return imageMap[`../assets/images/story/Image_${id}.webp`]?.default
  }

  return { resolveIcon, resolveImage }
}
